import React, { useState } from "react";
import format from "lib/format";
import Avatar from "Components/Base/DataDisplay/Avatar";
import styled from "styled-components";
import { getNameInitials } from "lib/utils";

const StyledAvatar = styled(Avatar)`
  background-color: #ccc;
`;

/**
 * ProfileAvatar component displays an avatar image with initials fallback.
 * If the image fails to load, it displays initials derived from the title.
 * @param {Object} props - Component props.
 * @param {string} props.size - Avatar size.
 * @param {string} props.personalId - Personal ID used to fetch the avatar image.
 * @param {string} [props.title="avatar"] - Title of the avatar, used for initials if image fails.
 * @param {string} [props.alt] - Alt text for the avatar image.
 * @param {string} [props.className] - CSS class name for styling.
 * @returns {JSX.Element} JSX element displaying the Avatar component.
 */

const ProfileAvatar = ({ size, personalId, title, alt, className }) => {
  const [imgSrc, setImgSrc] = useState(
    format.url(
      `/Personal/StreamImage.aspx?pres=1&pid=${personalId}&size=${size}&ddi=true`,
    ),
  );

  const initials = getNameInitials(title);

  const handleError = () => {
    setImgSrc(null);
  };

  return (
    <StyledAvatar
      size={size}
      title={title}
      alt={alt ?? title}
      className={className}
      src={imgSrc}
      onError={handleError}
      label={initials}
    />
  );
};

export default ProfileAvatar;
